import * as yup from 'yup';
import { MealType, values } from '../enums';
import { IBaseEntity } from './IBaseEntity';
import { IMealComponent, MealComponentSchema } from './IMealComponent';

export const BaseMealSchema = yup.object({
  mealType: yup.mixed().oneOf(values(MealType)),
  date: yup.string().notRequired(),
  location: yup.string().notRequired(),
  components: yup.array(MealComponentSchema).required(),
  nutritionProtocolId: yup.string().nullable(),
});

export const MealSchema = yup
  .object({
    residentId: yup.string().required(),
  })
  .concat(BaseMealSchema);

export interface IMeal extends Partial<IBaseEntity> {
  mealType: MealType;
  residentId: string;
  date?: string;
  location?: string;
  components: IMealComponent[];
  nutritionProtocolId?: string;
}
